import { faDollar } from '@fortawesome/duotone-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type FC } from 'react';
import { parsePriceLevel, PriceLevel } from '../price-level';
import { useFieldContext } from './contexts';
import { Field } from './Field';

interface Props {
  readonly isDisabled?: boolean;
  readonly isReadOnly?: boolean;
  readonly isRequired?: boolean;
  readonly isStatic?: boolean;
  readonly label: string;
}

export const PriceLevelField: FC<Props> = ({ isDisabled, isReadOnly, isRequired, isStatic, label }) => {
  const field = useFieldContext<PriceLevel | null>();
  return (
    <Field label={label} name={field.name}>
      <div className={'control has-icons-left'}>
        {isStatic ? (
          <div className={'control has-icons-left'}>
            <input
              className={'input is-static'}
              aria-readonly
              readOnly
              id={field.name}
              name={field.name}
              type={'text'}
              value={field.state.value ?? ''}
            />
            <span className={'icon is-small is-left'}>
              <FontAwesomeIcon icon={faDollar} />
            </span>
          </div>
        ) : (
          <div className={'select'}>
            <select
              id={field.name}
              onChange={(e) => {
                field.handleChange(parsePriceLevel(e.target.value));
              }}
              onBlur={field.handleBlur}
              value={field.state.value ?? ''}
              aria-readonly={isReadOnly}
              required={isRequired}
              disabled={isDisabled}
            >
              <option value={''}>Unknown</option>
              <option value={PriceLevel.Free}>Free</option>
              <option value={PriceLevel.Inexpensive}>Inexpensive</option>
              <option value={PriceLevel.Moderate}>Moderate</option>
              <option value={PriceLevel.Expensive}>Expensive</option>
              <option value={PriceLevel.VeryExpensive}>Very Expensive</option>
            </select>
          </div>
        )}
        <span className={'icon is-left is-small'}>
          <FontAwesomeIcon icon={faDollar} size={'sm'} />
        </span>
      </div>
      {field.state.meta.errors.length ? <p className={'help is-danger'}>{field.state.meta.errors.join(', ')}</p> : null}
    </Field>
  );
};
